import React from 'react';
import PropTypes from 'prop-types';
import Header from '../components/header';
import AlternativesCards from '../../../shared/library/cards/alternatives/alternatives-card-lite';
import glamorous from 'glamorous';
import Circular, {LARGE} from '../../../shared/library/indicators/indeterminate/circular';

export const Spinner = glamorous.div({
  display: 'flex',
  justifyContent: 'center',
  margin: '100px 0'
});

const Page = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
});

const Alternatives = ({topTools, loading}) => {
  if (loading) {
    return (
      <Spinner>
        <Circular size={LARGE} />
      </Spinner>
    );
  }
  if (topTools) {
    return (
      <Page>
        <Header />
        <AlternativesCards topTools={topTools} isMobile={false} />
      </Page>
    );
  }
  return null;
};

Alternatives.propTypes = {
  topTools: PropTypes.object,
  loading: PropTypes.bool
};

export default Alternatives;
